// 洗濯機: 前面に円形のドア表現（四角で代用）
import { Box } from '@react-three/drei'

export default function WashingMachineMesh({ width, height, depth, position, color, isSelected }) {
    const drumSize = Math.min(width, height) * 0.5

    return (
        <group>
            {/* 本体 */}
            <Box args={[width, height, depth]} position={position}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 操作パネル */}
            <Box args={[width * 0.8, height * 0.1, depth * 0.02]} position={[0, position[1] + height * 0.4, depth / 2 + 0.005]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} />
            </Box>

            {/* ドラム（四角で表現） */}
            <Box args={[drumSize, drumSize, depth * 0.02]} position={[0, position[1] - height * 0.05, depth / 2 + 0.01]}>
                <meshStandardMaterial color="#ddd" metalness={0.4} roughness={0.3} />
            </Box>

            {/* ドラム内側 */}
            <Box args={[drumSize * 0.8, drumSize * 0.8, depth * 0.02]} position={[0, position[1] - height * 0.05, depth / 2 + 0.015]}>
                <meshStandardMaterial color="#111" metalness={0.2} roughness={0.5} />
            </Box>

            {/* ワイヤーフレーム */}
            <Box args={[width, height, depth]} position={position}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
